"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedisQueueProviderType = void 0;
var RedisQueueProviderType;
(function (RedisQueueProviderType) {
    RedisQueueProviderType["PRODUCER"] = "PRODUCER";
    RedisQueueProviderType["WORKER"] = "WORKER";
})(RedisQueueProviderType || (exports.RedisQueueProviderType = RedisQueueProviderType = {}));
//# sourceMappingURL=queue.js.map